import React, { Component } from "react";
import { ValidationSignatureBaseView } from "../../views";
import { LocalStorageService, UserDocSuppService, WorkflowService } from "../../../services";

class ValidationSignatureBaseAction extends Component {
    constructor(props){
        super(props)
        this.state = {
            headerTitle: '',
            isLoadingView: false,
            token: '',
            user: {},
            showLoadingRequesting: false,
            showErrorRequesting: false,
            showCompletedRequesting: false,
            messageError: '',
            firstName: '',
            firstLastName: '',
            secondLastName: '',
            ineFrontImg: '',
            ineBackImg: '',
            backBtn: 'Regresar',
            rejectBtn: '',
            cancelBtn: '',
            validateBtn: '',
            showBackBtn: true,
            showRejectBtn: false,
            showCancelBtn: false,
            showNextBtn: false,
            statusCancel: 0,
            statusRejected: 0,
            statusValidated: [
                Number(process.env.REACT_APP_WORKFLOW_SIGNATURE_BASE_STATUS_300320)
            ]
        }
    }

    token = {}
    user = {}
    solicitudeId = ''
    workflowExecutionId = ''
    url = process.env.REACT_APP_MIFIRMA_API;
    localStorageService = new LocalStorageService ()
    userDocSuppService = new UserDocSuppService(this.url);
    workflowService = new WorkflowService(this.url);

    async componentDidMount(){
        this.token = this.localStorageService.getLocalStorageItem("token").idToken;
        this.user = this.localStorageService.getLocalStorageItem("user");
        let urlArr = window.location.href.split('/')
        this.solicitudeId = Number(urlArr[urlArr.length - 2])
        this.workflowExecutionId = urlArr[urlArr.length - 1]
        this.getUserSignatureBaseInfo()
        this.getWorkflowExecution()
    }

    toggleLoadingView = (value) => {
        this.setState({
            isLoadingView: value
        })
    }

    toggleLoadingRequesting = (value) => {
        this.setState({
            showLoadingRequesting: value,
        });
    };

    
    toggleErrorRequesting = (message, time, sendInbox, path) => {
        let sendTo = (path && path !== '') ? path : "/"
        this.setState({
            showErrorRequesting: true,
            messageError: message
        }, () => {
            setTimeout(() => {
                this.setState({
                    showErrorRequesting: false,
                })
                if (sendInbox) {
                    const locationState = this.props.location.state
                    if (locationState && locationState.from) {
                        this.props.history.push({
                            pathname: locationState.from,
                            state: locationState
                        })
                    } else {
                        this.props.history.push(sendTo)
                    }
                }
            }, time || 4000)
        })
    }

    toggleCompletedRequesting = (time, sendInbox, path) => {
        let sendTo = (path && path !== '') ? path : "/"
        this.setState({
            showCompletedRequesting: true,
        }, () => {
            setTimeout(() => {
                this.setState({
                    showCompletedRequesting: false,
                })
                if (sendInbox) {
                    const locationState = this.props.location.state
                    if (locationState && locationState.from) {
                        this.props.history.push({
                            pathname: locationState.from,
                            state: locationState
                        })
                    } else {
                        this.props.history.push(sendTo);
                    }
                }
            }, time || 4000)
        })
    }

    async getUserSignatureBaseInfo(){
        this.toggleLoadingView(true)
        let messageError = 'Ocurrió un error al consultar la información del usuario'

        try {
            let userInfo = await this.userDocSuppService.getUserSigantureBaseinfo(this.solicitudeId, this.token)
            if(userInfo && userInfo.data && Number(userInfo.statusCode) === 200){
                let { user, signature, ineFrontImg, ineBackImg } = userInfo.data
                let nameComplete = user.name
                let nameSplit = (nameComplete) ? nameComplete.split(' ') : ''
                let firstName = ''
                let firstLastName = ''
                let secondLastName = ''
                if (nameSplit.length === 1) {
                    firstName = `${nameSplit[0]}`
                }
        
                if (nameSplit.length === 2) {
                    firstName = `${nameSplit[0]}` 
                    firstLastName = `${nameSplit[1]}`
                }
        
                if (nameSplit.length === 3) {
                    firstName = `${nameSplit[0]}  `
                    firstLastName = `${nameSplit[1]}`
                    secondLastName = `${nameSplit[2]}`
                }
        
                if (nameSplit.length === 4) {
                    firstName = `${nameSplit[0]} ${nameSplit[1]}`
                    firstLastName = `${nameSplit[2]}`
                    secondLastName = `${nameSplit[3]}`
                }

                this.setState({
                    signatureImg: "data:image/png;base64," + signature,
                    ineFrontImg: "data:image/png;base64," + ineFrontImg,
                    ineBackImg: "data:image/png;base64," + ineBackImg,
                    firstName,
                    firstLastName,
                    secondLastName
                });
                this.toggleLoadingView(false)

            }else{
                this.toggleLoadingView(false)
                this.toggleErrorRequesting(messageError, 4000, true, '/')
            }
        } catch (error) {
            this.toggleLoadingView(false)
            this.toggleErrorRequesting(messageError, 4000, true, '/')
        }
    }

    async getWorkflowExecution() {
        let errorMessage = 'Ocurrió un error al consultar el workflow del contrato'

        try {
          let workflowExecution = await this.workflowService.getWorkFlowExecutionById(this.workflowExecutionId, this.token);
          if (workflowExecution && workflowExecution.data && Number(workflowExecution.statusCode) === 200) {
            let statusCurrent = workflowExecution.data.workflowStatusDescriptions.statusCurrent.status;
            let titleHeader =  workflowExecution.data.workflowStatusDescriptions.statusCurrent.name
            let statusIsEnable = this.state.statusValidated.includes(statusCurrent)
            let nameBtn = (workflowExecution.data.workflowStatusDescriptions && workflowExecution.data.workflowStatusDescriptions.statusNext && workflowExecution.data.workflowStatusDescriptions.statusNext.name) ? workflowExecution.data.workflowStatusDescriptions.statusNext.name : 'Validar usuario'
            
            //Back btn 
            let statusBackBtn = workflowExecution.data.workflowStatusDescriptions.statusBack.status
            let backBtnLabel = workflowExecution.data.workflowStatusDescriptions.statusBack.name

            //status cancel
            let cancelBtnName = (workflowExecution.data.workflowStatusDescriptions.statusCurrent.statusCancel && workflowExecution.data.workflowStatusDescriptions.statusCurrent.statusCancel.label) ? workflowExecution.data.workflowStatusDescriptions.statusCurrent.statusCancel.label : ''
            let statusCancel = (workflowExecution.data.workflowStatusDescriptions.statusCurrent.statusCancel && workflowExecution.data.workflowStatusDescriptions.statusCurrent.statusCancel.status) ? workflowExecution.data.workflowStatusDescriptions.statusCurrent.statusCancel.status : ''
            let showBtnCancelStatus = (cancelBtnName && statusCancel) ? true : false
    
            //verify if user has permission
            let rolesMember = workflowExecution.data.workflowExecutionMembers.filter((member) => member.email === this.user.userMetaData.userA3Cloud.email)
            let userPermissionWorkflowArr = JSON.parse(workflowExecution.data.workflowStatus.membersTypeAllowToShow)
            let allPermission = rolesMember.map(role => {
              let permissionUser = userPermissionWorkflowArr.includes(role.workflowExecutionMemberTypeId)
              return permissionUser
            })
    
            let userHasPermission = allPermission.includes(true) ? true : false
            let statusNextBtn = workflowExecution.data.workflowStatusDescriptions.statusNext.status
            let showBtnNextStatus = (!statusIsEnable || !userHasPermission || statusNextBtn <= 0) ? false : true
            let showBtnBacktStatus = (!statusIsEnable || !userHasPermission || statusBackBtn <= 0) ? false : true
            showBtnCancelStatus = (!statusIsEnable || !userHasPermission) ? false : true
             
            this.setState({
              workflow: workflowExecution.data,
              headerTitle: titleHeader,
              status: statusCurrent,
              showNextBtn: showBtnNextStatus,
              validateBtn: nameBtn,
              rejectBtn: backBtnLabel,
              userHasPermission,
              statusNextBtn,
              statusBackBtn,
              cancelBtn:cancelBtnName,
              statusCancel,
              showCancelBtn:showBtnCancelStatus,
              showRejectBtn: showBtnBacktStatus
            });
          } else {
            this.toggleLoadingRequesting(false)
            this.toggleErrorRequesting(errorMessage, 4000, true, "/")
          }
        } catch (error) {
            this.toggleLoadingRequesting(false)
            this.toggleErrorRequesting(errorMessage, 4000, true, "/")
        }
    }

    changeStatusValidationSigantureBase = async(workflowExecutionId, action, statusDefined, updateSignature, statusSignatureBaseUpdated) => {
        this.toggleLoadingRequesting(true)
        let errorMessage = 'Ocurrió un error al enviar a validar la firma base'

        try {
            let workflowValidationSiganture = await this.workflowService.changeStatusWorkflowValidationSigantureBase(workflowExecutionId, action, statusDefined, updateSignature, statusSignatureBaseUpdated, this.token)
            if(workflowValidationSiganture && workflowValidationSiganture.data && Number(workflowValidationSiganture.statusCode) === 200){
                this.toggleLoadingRequesting(false)
                this.toggleCompletedRequesting(4000, true, '/')
            }else{
                this.toggleLoadingRequesting(false)
                this.toggleErrorRequesting(errorMessage, 4000, false, "/")
            }
        } catch (error) {
            this.toggleLoadingRequesting(false)
            this.toggleErrorRequesting(errorMessage, 4000, false, "/")
        }
    }

    handleBack = async() => {
        this.history.push.goBack()
    }
    
    handleReject = async() => {
        let workflowExecutionId = this.workflowExecutionId
        let action = 'back' 
        let statusDefined
        let updateSignature = true
        let statusSignatureBaseUpdated =  process.env.REACT_APP_SIGNATURE_BASE_STATUS_REJECTED
        this.changeStatusValidationSigantureBase(workflowExecutionId, action, statusDefined, updateSignature, statusSignatureBaseUpdated)
    }
    
    handleCancel = async(statusCancel) => {
        let workflowExecutionId = this.workflowExecutionId
        let action = 'defined' 
        let statusDefined = statusCancel
        let updateSignature = true
        let statusSignatureBaseUpdated =  process.env.REACT_APPSIGNATURE_BASE_STATUS_CANCELED
        this.changeStatusValidationSigantureBase(workflowExecutionId, action, statusDefined, updateSignature, statusSignatureBaseUpdated)
    }

    handleValidate = () => {
        let workflowExecutionId = this.workflowExecutionId
        let action = 'next' 
        let statusDefined 
        let updateSignature = true
        let statusSignatureBaseUpdated =  process.env.REACT_APP_SIGNATURE_BASE_STATUS_APPROVED
        this.changeStatusValidationSigantureBase(workflowExecutionId, action, statusDefined, updateSignature, statusSignatureBaseUpdated)
    }

    render(){
        return(
            <ValidationSignatureBaseView 
                {...this.props}
                {...this.state}

                changeStatusValidationSigantureBase={this.changeStatusValidationSigantureBase}
                handleBack={this.handleBack}
                handleReject={this.handleReject}
                handleCancel={this.handleCancel}
                handleValidate={this.handleValidate}
            />
        )
    }
}

export { ValidationSignatureBaseAction as default }